import type {AdSample} from '../types/AdSample';
import type {Sample} from '../types/Sample';
import {AnalyticsCall} from '../utils/AnalyticsCall';

import type {Backend} from './Backend';

/**
 * The `RemoteBackend` class is responsible for actually sending out the samples using the {@link AnalyticsCall} class.
 * Before each sample is sent, the `RemoteBackend` attaches a license key to the sample.
 *
 * @implements {Backend}
 */
export class RemoteBackend implements Backend {
  private readonly analyticsCall: AnalyticsCall;
  private readonly licenseKey: string;

  constructor(backendBaseUrl: string, licenseKey: string) {
    this.analyticsCall = new AnalyticsCall(backendBaseUrl);
    this.licenseKey = licenseKey;
  }

  sendRequest(sample: Sample): void {
    sample.key = this.licenseKey;
    this.analyticsCall.sendRequest(sample);
  }

  sendUnloadRequest(sample: Sample): void {
    sample.key = this.licenseKey;
    this.analyticsCall.sendUnloadRequest(sample);
  }

  sendAdRequest(adSample: AdSample): void {
    adSample.key = this.licenseKey;
    this.analyticsCall.sendAdRequest(adSample);
  }

  sendUnloadAdRequest(adSample: AdSample): void {
    adSample.key = this.licenseKey;
    this.analyticsCall.sendUnloadAdRequest(adSample);
  }
}
